import { HotelStars } from '@lt/components';
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import Wishlist from 'src/components/Wishlist';
import PriceBadgeContainer from '../../containers/PriceBadge';
import Breadcrumbs from '../Breadcrumbs';
import LabelList from '../LabelList';
import ShareSocial from '../ShareSocial';
import ShortInfo from './ShortInfo';

import styles from './header.module.css';

const Header = ({
  title,
  stars,
  breadcrumbs,
  subheader,
  isMobile,
  badgeList,
  isHotelOnly,
  isWishlistAvailable,
  hotelId,
}) => (
  <div
    className={classnames(styles.container, {
      [styles.containerMobile]: isMobile,
    })}
  >
    <div
      className={classnames(styles.starsLocation, {
        [styles.starsLocationMobile]: isMobile,
      })}
    >
      <HotelStars className={styles.hotelStars} value={stars} />
      {breadcrumbs && (
        <Breadcrumbs
          className={classnames({
            [styles.breadcrumbsMobile]: isMobile,
          })}
          items={breadcrumbs}
          smartFade={!isMobile}
          fullWidth={isMobile}
          isMobile={isMobile}
        />
      )}
      {!isMobile && (
        <ShareSocial
          className={styles.shareSocialDesktop}
          description={subheader}
        />
      )}
      {isMobile && (
        <Wishlist wishlistIdentifier={hotelId} type="hotel" isMobileHotelPage />
      )}
    </div>
    <div className={styles.row}>
      <div
        className={classnames(styles.headerContent, {
          [styles.headerContentMobile]: isMobile,
        })}
      >
        <div className={styles.title}>
          <h1
            className={classnames(styles.h1, {
              [styles.h1Mobile]: isMobile,
            })}
          >
            <span className={styles.titleBold}>{title}</span>
          </h1>
          {!isMobile && <PriceBadgeContainer isHotelOnly={isHotelOnly} />}
        </div>
        <div
          className={classnames(styles.subHeaderWrapper, {
            [styles.subHeaderWrapperMobile]: isMobile,
          })}
        >
          <LabelList badges={badgeList} />

          {subheader && <ShortInfo text={subheader} isMobile={isMobile} />}
        </div>
      </div>
      {!isMobile && isWishlistAvailable && (
        <Wishlist type="hotel" wishlistIdentifier={hotelId} isHotelPage />
      )}
    </div>
    {isMobile && (
      <ShareSocial
        className={styles.shareSocialMobile}
        stickTo="left"
        description={subheader}
      />
    )}
  </div>
);

Header.defaultProps = {
  subheader: null,
  isMobile: false,
  badgeList: null,
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
  stars: PropTypes.number.isRequired,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  badgeList: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
    }),
  ),
  subheader: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default Header;
